import DateSelectDialog from './dateSelectDialog'
import ScanDilalog from './scanDilalog'

export default {
  install(Vue){
    //注册全局组件
    Vue.component('DateSelectDialog',DateSelectDialog)
    Vue.component('ScanDilalog',ScanDilalog)
  }
}